<template>
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="message.created_at"
      placement="left"
    >
      <div class="from-me">
        <span>
          {{ message.message }}
        </span>
      </div>
    </el-tooltip>
    <a
      href="#"
      class="talkDeleteMessage"
      title="Delete Message"
      v-on:click.prevent="$emit('remove-message', message.id)"
      ><i class="fa fa-close"></i
    ></a>
  </div>
</template>

<script>
export default {
  props: ["message"]
};
</script>
